import React from "react";
import { SERVICE_DATA } from "../../constants/ServiceConstant";
import { Link } from "react-router-dom";
import LearnMoreButton from "../../common/LearnMoreButton";

const ServiceGrid = () => {
  return (
    <div className="row g-4 justify-content-center">
      {SERVICE_DATA.map((service, index) => (
        <div
          key={index}
          className="col-lg-4 col-md-6 col-sm-10 wow animate__animated animate__fadeInUp"
          data-wow-delay={service.delay}
          data-wow-duration="1500ms"
        >
          <div className="single-service-card magnetic-item">
            <div className="icon"> {React.createElement(service.icon)} </div>
            <div className="services-content">
              <h3>
                <Link to={`/services/${service.id}`}>{service.title} </Link>
              </h3>
              <p>
                {service.description.length > 120
                  ? service.description.substring(0, 120) + "..."
                  : service.description}
              </p>
              <LearnMoreButton link={`/services/${service.id}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceGrid;
